/**
 * 二次授权的错误提示
 * */
import React, { PureComponent } from 'react';
import { Modal } from 'antd';
import './SecondaryAuthError.scss';

import {
  _change_sy_phone_modal,
  _change_sy_secondary_auth_error,
  _change_sy_user_login_info,
  _show_login_modal,
} from '../../../store/Action';
import Util from '../../../script/util';

export default class SecondaryAuthError extends PureComponent {
  // 关闭此弹窗， 并非右上角的关闭按钮
  hideModal = () => {
    _change_sy_secondary_auth_error({ wx: false, qq: false, phone: false });
  };
  // 右上角的关闭按钮
  onCancel = () => {
    _change_sy_user_login_info(null); // 用户迁移 - 清除用户信息
    this.hideModal();
  };

  // 重新登录
  handleAgain = () => {
    this.onCancel();
    _show_login_modal();
  };
  // 重新授权登录
  handleRestart = () => {
    const { sySecondaryAuthError } = this.props.base;

    if (sySecondaryAuthError.wx) {
      this.props.showWeixinLogin();
      // _show_login_modal();
    } else if (sySecondaryAuthError.qq) {
      this.props.showQQLogin();
      // _show_login_modal();
    } else if (sySecondaryAuthError.phone) {
      _change_sy_phone_modal(true);
    }
    this.hideModal();
  };

  // 手机号的错误提示
  renderPhoneError = () => {
    const { syUserLoginInfo } = this.props.base;
    let { phone, areaCode } = syUserLoginInfo;
    return (
      <ul className="auth-error-ul">
        <li className="auth-error-item is-not-point">
          {phone ? (
            <p>
              当前绑定的手机号与原绑定手机号不一致。请使用当前登录账号的
              <span className="red-text">
                原绑定手机号 {areaCode || ''}{' '}
                {Util.getPrivatePhone(phone, areaCode || '86')}
              </span>{' '}
              验证身份。
            </p>
          ) : (
            <p>
              该账号未绑定手机号，请通过
              <span className="red-text">【账号找回申诉】</span>
              流程，绑定手机号，重新登录。
            </p>
          )}
        </li>
      </ul>
    );
  };

  // 微信和QQ的错误提示
  renderWXAndQQError = () => {
    const { sySecondaryAuthError } = this.props.base;

    const typeText = sySecondaryAuthError.wx ? '微信' : 'QQ';
    return (
      <ul className="auth-error-ul">
        <li className="auth-error-item">
          <p>
            当前登录的{typeText}号和身份验证的
            <span className="red-text">{typeText}号不一致，</span>
            导致验证不通过。
          </p>
        </li>
        <li className="auth-error-item">
          <p>
            同一个{typeText}号登录、身份验证，
            <span className="red-text">但使用了虚拟头像昵称，</span>
            导致验证不通过。
          </p>
        </li>
      </ul>
    );
  };

  // 错误按钮
  renderButtonError = () => {
    const { sySecondaryAuthError, syUserLoginInfo } = this.props.base;
    const phone = syUserLoginInfo?.phone;

    const typeText = sySecondaryAuthError.wx
      ? '微信'
      : sySecondaryAuthError.qq
        ? 'QQ'
        : '手机号';
    return (
      <div className="btn-wrap">
        <button className="daidai-btn-primary again" onClick={this.handleAgain}>
          登录账号不对？重新登录
        </button>
        {sySecondaryAuthError.phone && !phone ? (
          <button
            className="daidai-btn-primary restart"
            onClick={this.handleOpenBindPhone}
          >
            账号找回申诉
          </button>
        ) : (
          <button
            className="daidai-btn-primary restart"
            onClick={this.handleRestart}
          >
            更换{typeText}，重新授权
          </button>
        )}
      </div>
    );
  };

  // 打开换绑手机号H5
  handleOpenBindPhone = () => {
    this.onCancel();
    // 打开 H5 页面
    this.props.otherChangeBindPhoneElement &&
      this.props.otherChangeBindPhoneElement.showModal();
  };

  render() {
    const { sySecondaryAuthError } = this.props.base;
    return (
      <Modal
        open={
          sySecondaryAuthError.wx ||
          sySecondaryAuthError.qq ||
          sySecondaryAuthError.phone
        }
        title="身份验证"
        wrapClassName="daidai-modal-style has-top-border"
        centered={true}
        footer={null}
        keyboard={false}
        maskClosable={false}
        width="600px"
        onCancel={this.onCancel}
      >
        <div className="second-auth-error-result">
          <div className="icon-error" />
          <p className="auth-error-type">
            {sySecondaryAuthError.wx
              ? '微信'
              : sySecondaryAuthError.qq
                ? 'QQ'
                : '绑定手机号'}
            验证不通过
          </p>

          {sySecondaryAuthError.phone && this.renderPhoneError()}
          {(sySecondaryAuthError.wx || sySecondaryAuthError.qq) &&
            this.renderWXAndQQError()}

          {this.renderButtonError()}
        </div>
      </Modal>
    );
  }
}
